import {
  CONNECTIVITY_GETTERS_ENUM,
} from './connectivity.eum';

export const connectivityGetters = {
  [CONNECTIVITY_GETTERS_ENUM.GET_IS_CONNECTED_TO_INTERNET](state) {
    return state.isConnectedToInternet;
  },
};
